import Signin from "./Signin";

export default function Community (){
    return <>
       <Signin/>
    </>
}